import React, { useEffect, useState } from 'react';
import UserLayout from './UserLayout';
import { getMyActiveOrders } from '../api/order';
import { useNavigate } from 'react-router-dom';

export default function MyOrdersPage({ user, setUser }: { user: any, setUser: (user: any) => void }) {
  const [orders, setOrders] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem('user');
    const parsed = stored ? JSON.parse(stored) : null;
    const userId = parsed?.userId || parsed?.UserId || parsed?.id || null;
    const fetchOrders = async () => {
      try {
        setLoading(true);
        const data = await getMyActiveOrders(userId);
        setOrders(Array.isArray(data) ? data : []);
      } catch (e: any) {
        setError('Failed to load orders');
      } finally {
        setLoading(false);
      }
    };
    fetchOrders();
  }, []);

  return (
    <UserLayout user={user} setUser={setUser} hideSlider={true}>
      <div className="container">
        <h2 style={{ marginTop: 0 }}>My Orders</h2>
        {loading ? (
          <div style={{ color: '#888' }}>Loading...</div>
        ) : error ? (
          <div className="error-msg">{error}</div>
        ) : orders.length === 0 ? (
          <div style={{ color: '#666' }}>No active orders.</div>
        ) : (
          <table className="category-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Order ID</th>
                <th>Items</th>
                <th>Total</th>
                <th>Completed</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((o, idx) => (
                <tr key={o.orderId}>
                  <td>{idx + 1}</td>
                  <td>{o.orderId}</td>
                  <td>{o.products?.reduce((total: number, p: any) => total + (p.quantity || 0), 0) || 0}</td>
                  <td style={{ fontWeight: 700, color: '#1976d2' }}>{o.totalPrice}</td>
                  <td>{o.isComplete ? '✔️' : '—'}</td>
                  <td>
                    <button className="admin-btn" onClick={() => navigate(`/order/${o.orderId}`)}>View</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </UserLayout>
  );
}


